'use client';

import { Grid, GridItem, Image, Text } from '@chakra-ui/react';

import { useNetwork } from 'context/network';
import { useGiftcardsPagesLayoutContent } from 'context/giftcardsPagesLayoutContent';
import { Link } from '../Link';

export const Sponsors = () => {
  const { network } = useNetwork();

  const { partnersAndSponsors } = useGiftcardsPagesLayoutContent();

  const { sponsors = [] } = network ?? {};

  const isSponsorsArrayOdd = sponsors.length % 2 === 1;

  if (!sponsors.length) return null;

  return (
    <>
      <Text mb="1.25rem" fontSize="0.75rem" textAlign="center">
        {partnersAndSponsors.title}
      </Text>

      <Grid gridTemplateColumns="repeat(2, 1fr)" gap="1rem" w="full">
        {sponsors.map((sponsor, index) => {
          const isLastOne = sponsors.length - 1 === index;

          const logoElement = (
            <Image
              src={sponsor.logo.url}
              w="9.375rem"
              h="5rem"
              objectFit="cover"
              alt={`${sponsor.name} Logo`}
            />
          );

          return (
            <GridItem
              key={sponsor.id}
              colSpan={isSponsorsArrayOdd && isLastOne ? 2 : 1}
              alignItems="center"
              justifyContent="center"
            >
              {sponsor.www ? (
                <Link
                  href={sponsor.www}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  w="full"
                  h="full"
                >
                  {logoElement}
                </Link>
              ) : (
                logoElement
              )}
            </GridItem>
          );
        })}
      </Grid>
    </>
  );
};
